<template>
  <div class="top-menu-form">
    <button
      class="button search-more"
      slot="trigger"
      aria-controls="searchmore"
      @click="isSearchMoreOpen = !isSearchMoreOpen"
    >
      <b-icon icon="magnify" />
    </button>
    <b-collapse
      aria-id="searchmore"
      :open.sync="isSearchMoreOpen"
      class="collapsed-menu"
    >
      <div class="collapsed-menu-title">Advanced Search Options</div>
      <div v-for="(item, index) in info" :key="index">
        <a :href="item.url">{{ item.label }}</a>
      </div>
    </b-collapse>
    <form v-on:submit.prevent class="form-search">
      <b-field>
        <b-input class="input-form" v-model="search"></b-input>
        <p class="control">
          <button class="button" @click="triggerSearch">Search</button>
        </p>
      </b-field>
    </form>
  </div>
</template>

<script>
export default {
  name: "HeaderTopForm",
  data() {
    return {
      search: "",
      isSearchMoreOpen: false
    };
  },
  computed: {
    gettySearchUrl() {
      try {
        return new URL(
          `${process.env.BASE_URL}?qt=${this.search}`,
          "https://www.getty.edu"
        );
      } catch (error) {
        return new URL(`/search?qt=${this.search}`, "https://www.getty.edu");
      }
    }
  },
  props: {
    info: Array
  },
  methods: {
    triggerSearch() {
      if (this.gettySearchUrl.href) {
        location.href = this.gettySearchUrl.href;
      }
    }
  }
};
</script>
